import { render, staticRenderFns } from "./product_create.vue?vue&type=template&id=f3bf02e2&scoped=true&"
import script from "./product_create.vue?vue&type=script&lang=js&"
export * from "./product_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf02e2",
  null
  
)

export default component.exports